import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './FarecardAdd.css';

type FarecardAddProps = {
  goBack: () => void;
  addVirtual: () => void;
  addPhysical: () => void;
  allowVirtual: boolean;
};

export default function FarecardAdd({
  goBack,
  addVirtual,
  addPhysical,
  allowVirtual,
}: FarecardAddProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="ion-text-center">
        <IonIcon
          className="farcards-add-circle"
          src="assets/icon/card-add-circle.svg"
        ></IonIcon>
      </div>

      <h1 className="h1 pt-2 ion-text-center">{t('farecards.addcard')}</h1>
      <p className="pt-1 pb-5 instructions ion-text-center">
        {t('farecards.addinstruction')}
      </p>

      {allowVirtual ? (
        <>
          <div className="ion-text-center">
            <IonButton
              className="btn-default "
              expand="block"
              onClick={addVirtual}
            >
              {t('farecards.createvirtual')}
            </IonButton>
          </div>
          <div className="ion-text-center">
            <IonButton
              onClick={addPhysical}
              fill="outline"
              expand="block"
              className="btn-default"
            >
              {t('farecards.createphysical')}
            </IonButton>
          </div>
        </>
      ) : (
        <div className="ion-text-center">
          <IonButton
            onClick={addPhysical}
            className="btn-default "
            expand="block"
          >
            {t('farecards.createphysical')}
          </IonButton>
        </div>
      )}
      <div className="pt-1 pb-3 ion-text-center">
        <IonButton onClick={goBack} fill="clear" expand="block">
          <b>{t('home.cancel')}</b>
        </IonButton>
      </div>
    </>
  );
}
